import axios from 'axios';
import enviroment from '../enviroment';
/* import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { fpalphaAPI } from './FPAlphaAPI'; */

export const socketAPI = axios.create({
    baseURL: enviroment.socketUrl,
});

/* const refreshAuthLogic = async (failedRequest) => {
    const refreshToken = localStorage.getItem('refreshToken');
    console.log('Refreshing...' + refreshToken);

    return axios.post(`${fpalphaAPI.defaults.baseURL}/sys/auth/refresh`, { refreshToken }).then(response => {
        const { accessToken } = response.data;
        if (accessToken) {
            localStorage.setItem('accessToken', accessToken);
            return Promise.resolve();
        }

        return Promise.reject();
    }).catch(err => {
        window.location = '/login?error=session_expired';
    });
}

createAuthRefreshInterceptor(socketAPI, refreshAuthLogic);

socketAPI.interceptors.request.use((request) => {
    const accessToken = localStorage.getItem('accessToken');
    request.headers.authorization = `Bearer ${accessToken}`;
    return request;
}); */